<template>
    <div>
        <limitless-page-header
            title="Hantera kort"
            :sub-title="(this.order ? 'Order: ' + this.order.OrderID + ' - ' + this.order.customer.CompanyName : '')"
            :title-template="'Hantera kort' + (this.order ? ' - Order #' + this.order.OrderID + ' (' +  this.order.customer.CompanyName + ')' : '')"
        >
            <template #header-elements>
                <limitless-page-header-button v-if="order" :url="'/cardorders/' + order.OrderID" icon="icon-clipboard3">Till order</limitless-page-header-button>
                <limitless-page-header-button v-if="order && order.customer" :route="{ name: 'customers.edit', params: { id: order.customer.CustomerID } }" icon="icon-office">Till kund</limitless-page-header-button>
            </template>
        </limitless-page-header>
        <div class="content" v-if="busy_loading">
            <i class="icon-spinner2 spinner"></i>
        </div>
        <div class="content" v-else-if="!busy_loading && order">
            <div class="card">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Kortserie</th>
                            <th>Kortserie</th>
                            <th></th>
                            <th class="text-right">Totalt på order</th>
                            <th class="text-right">Aktiverade</th>
                            <th class="text-right">Spärrade</th>
                            <th class="text-right">Kvar att aktivera</th>
                        </tr>
                    </thead>
                    <tbody v-for="(item, i_index) in order_items" :key="i_index">
                        <tr :class="{
                            'alpha-success': (item.TotalOnOrder - item.serie.activated_cards) <= 0,
                            'font-weight-bold': (item.TotalOnOrder - item.serie.activated_cards) > 0
                        }">
                            <td>{{ item.CardSeriesID }}</td>
                            <td>{{ item.serie.SeriesName }}</td>
                            <td><button type="button" class="btn btn-warning btn-sm" @click="showModalBlockCards(item)"><i class="icon-blocked mr-2"></i>Spärra kort</button></td>
                            <td class="text-right">{{ item.TotalOnOrder }}</td>
                            <td class="text-right">{{ item.serie.activated_cards }}</td>
                            <td class="text-right">{{ item.serie.blocked_cards }}</td>
                            <td class="text-right">{{ (item.TotalOnOrder - item.serie.activated_cards + item.serie.blocked_cards) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="form-group">
                <div class="btn-group">
                    <button type="button" class="btn" :class="{ 'btn-primary': section === 'scan', 'btn-light': section !== 'scan' }" @click="section = 'scan'">
                        Skanna kort
                    </button>
                    <button type="button" class="btn" :class="{ 'btn-primary': section === 'interval', 'btn-light': section !== 'interval' }" @click="section = 'interval'" :disabled="action === 'block'">
                        Kortintervall
                    </button>
                </div>

                <div class="btn-group ml-4">
                    <button type="button" class="btn" :class="{ 'btn-primary': action === 'activate', 'btn-light': action !== 'activate' }" @click="setAction('activate')">
                        AKTIVERA kort
                    </button>
                    <button type="button" class="btn" :class="{ 'btn-danger': action === 'block', 'btn-light': action !== 'block' }" @click="setAction('block')" :disabled="section === 'interval'">
                        SPÄRRA kort
                    </button>
                </div>
            </div>

            <div class="row" v-if="section === 'scan'">
                <div class="col-lg-3">
                    <div class="form-group">
                        <div class="input-group">
                            <span class="input-group-prepend">
                                <span class="input-group-text">SCAN: </span>
                            </span>
                            <input type="text" ref="scaninput" autofocus class="form-control d-inline" v-model="scan_input" @blur="focusScanInput()">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-if="section === 'interval'">
                <div class="col-lg-3">
                    <div class="form-group">
                        <div class="input-group">
                            <span class="input-group-prepend">
                                <span class="input-group-text">FRÅN: </span>
                            </span>
                            <input type="text" class="form-control d-inline" v-model="card_interval_from">
                        </div>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="form-group">
                        <div class="input-group">
                            <span class="input-group-prepend">
                                <span class="input-group-text">TILL: </span>
                            </span>
                            <input type="text" class="form-control d-inline" v-model="card_interval_to">
                        </div>
                    </div>
                </div>
                <div class="col-lg-3">
                    <limitless-button type="button" ref="btnactivateinterval" :busy="busy_activating" class="btn" btn-class="btn-primary" saved-text="KLAR!" @click="activateCardInterval(false)">Aktivera</limitless-button>
                </div>
            </div>

            <div class="card">
                <div class="card-header bg-light">
                    <h6 class="card-title"><span class="font-weight-semibold">Loggar</span></h6>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="card card-body text-success" style="overflow-y: scroll; height: 200px;" ref="logsuccess">
                                <div v-for="(success, s_index) in log.success" :key="'s-' + s_index" v-text="success"></div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card card-body text-danger" style="overflow-y: scroll; height: 200px;" ref="logerror">
                                <div v-for="(error, e_index) in log.error" :key="'e-' + e_index" v-text="error"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <b-modal id="modal-block-cards" title="Spärra kort" @ok="blockCards" @hidden="block.open = false" @show="block.open = true">
                <template #default="{ ok }" v-if="block.item">
                    <p class="text-left">
                        Order: {{ order.OrderID }} - {{ order.customer.CompanyName }}<br>
                        Kortserie: {{ block.item.serie.CardSeriesID }} - {{ block.item.serie.SeriesName }}
                    </p>
                    <br>
                    <br>
                    <form @submit.prevent="ok()">
                        <ValidationObserver ref="blockform">
                            <ValidationProvider vid="selection" name="Korturval" rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label class="d-block">Vilka kort vill du spärra?</label>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" class="custom-control-input" name="block_cards" id="rdo-all" v-model="block.form.selection" value="all">
                                        <label class="custom-control-label" for="rdo-all">Spärra alla kort</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="radio" class="custom-control-input" name="block_cards" id="rdo-notredeemed" v-model="block.form.selection" value="notredeemed">
                                        <label class="custom-control-label" for="rdo-notredeemed">Spärra endast oinlösta kort</label>
                                    </div>
                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                            <ValidationProvider vid="comment" name="Kommentar" rules="required" v-slot="{ errors }">
                                <div class="form-group">
                                    <label>Kommentar</label>
                                    <input type="text" class="form-control" v-model="block.form.comment" :class="{ 'border-danger':errors[0] }">
                                    <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                </div>
                            </ValidationProvider>
                        </ValidationObserver>
                    </form>
                </template>
                <template #modal-footer="{ ok, cancel }">
                    <button type="button" class="btn btn-light" @click="cancel()">Avbryt</button>
                    <limitless-button ref="btnblockcards" type="button" @click="ok()" :busy="busy_blocking" icon="icon-blocked" btn-class="btn-warning">SPÄRRA</limitless-button>
                </template>
            </b-modal>
        </div>
        <div class="content" v-else>
            <i>Något gick fel...</i>
        </div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import { debounce } from 'lodash';
import getError from '@services/ErrorHelper';

export default {
    name: 'CardOrderActivateCards',
    components: {
        LimitlessButton,
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
    },
    props: {
        id: {
            type: [Number, String],
            default: 0,
        },
    },
    data: () => ({
        busy_loading: true,
        busy_blocking: false,
        order: null,
        scan_input: '',
        busy_activating: false,
        section: 'scan',
        action: 'activate',
        card_interval_from: '',
        card_interval_to: '',
        log: {
            success: [],
            error: [],
        },
        block: {
            open: false,
            item: null,
            form: {
                comment: '',
                selection: null,
            },
        },
    }),
    watch: {
        scan_input: debounce(function scanInputDebounce(val) {
            if (val) {
                this.activateCard(val);
            }
            this.scan_input = '';
        }, 300),
        section(val) {
            if (val === 'scan') {
                this.$nextTick(() => {
                    this.focusScanInput();
                });
            }
        },
    },
    mounted() {
        this.getOrderInfo();
    },
    methods: {
        async setAction(action) {
            let doSet = true;
            if (action === 'block') {
                doSet = false;
                await this.$swal({
                    title: 'Är du säker att du vill SPÄRRA kort?',
                    text: 'Inmatade kortnummer kommer att spärras oavsätt kortserie och kopplad order.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Ja!',
                    cancelButtonText: 'Avbryt',
                }).then((result) => {
                    if (result.isConfirmed) {
                        doSet = true;
                    }
                });
            }

            if (doSet) {
                this.action = action;
            }
        },
        async getOrderInfo() {
            await apiClient.get('/vue/cardorder/' + this.id + '/activate/orderinfo')
                .then((response) => {
                    if (response.data.order) {
                        this.order = response.data.order;
                    }
                }).finally(() => {
                    this.busy_loading = false;
                });
        },
        async activateCard(card, force = false) {
            this.busy_activating = true;
            await apiClient.post('/vue/cardorder/' + this.order.OrderID + '/' + this.action + '/card', { card_number: card, force })
                .then((response) => {
                    if (response.data.order) {
                        this.order = response.data.order;
                    }
                    if (response.data.card_number) {
                        this.addToLog(response.data.action.toUpperCase() + ': ' + response.data.card_number + ' (SERIE: ' + response.data.card_series + ')', 'success');
                    }
                }).catch(async (error) => {
                    if (this.action === 'activate' && !force && error.response && error.response.data && error.response.data.error && error.response.data.allow_force) {
                        let doChange = false;
                        await this.$swal({
                            text: error.response.data.error + '. Vill du aktivera ändå?',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Ja!',
                            cancelButtonText: 'Nej',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                doChange = true;
                            }
                        });
                        if (doChange) {
                            await this.activateCard(card, true);
                        }
                    } else if (error.response && error.response.data && error.response.data.error) {
                        this.addToLog('ERR: ' + card + ' - ' + error.response.data.error, 'error');
                    } else {
                        this.addToLog('ERR: ' + card + ' - Något gick fel', 'error');
                    }
                }).finally(() => {
                    this.busy_activating = false;
                });
        },
        async activateCardInterval(force = false) {
            if (this.card_interval_to && this.card_interval_from) {
                this.busy_activating = true;
                await apiClient.post('/vue/cardorder/' + this.order.OrderID + '/' + this.action + '/cardinterval', {
                    card_number_start: this.card_interval_from,
                    card_number_end: this.card_interval_to,
                    force,
                })
                    .then((response) => {
                        if (response.data.order) {
                            this.order = response.data.order;
                        }
                        if (response.data.message) {
                            this.addToLog('ACTIVATE: ' + response.data.message, 'success');
                        }
                        this.$refs.btnactivateinterval.triggerSaved();
                    }).catch(async (error) => {
                        if (this.action === 'activate' && !force && error.response && error.response.data && error.response.data.error && error.response.data.allow_force) {
                            let doChange = false;
                            await this.$swal({
                                text: error.response.data.error + '. Vill du aktivera ändå?',
                                icon: 'warning',
                                showCancelButton: true,
                                confirmButtonText: 'Ja!',
                                cancelButtonText: 'Nej',
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    doChange = true;
                                }
                            });
                            if (doChange) {
                                await this.activateCardInterval(true);
                            }
                        } else if (error.response && error.response.data && error.response.data.error) {
                            this.addToLog('ERR: ' + error.response.data.error, 'error');
                        } else {
                            this.addToLog('ERR: Något gick fel', 'error');
                        }
                    }).finally(() => {
                        this.busy_activating = false;
                    });
            } else {
                this.$refs.btnactivateinterval.triggerFailed();
            }
        },
        addToLog(text, target) {
            this.log[target].push(text);
            const objDiv = this.$refs['log' + target];
            if (objDiv) {
                objDiv.scrollTop = objDiv.scrollHeight;
            }
        },
        focusScanInput() {
            if (!this.block.open) {
                this.$refs.scaninput.focus();
            }
        },
        async showModalBlockCards(item) {
            this.block.item = item;
            this.block.form.comment = '';
            this.block.form.selection = null;
            this.$bvModal.show('modal-block-cards');
        },
        async blockCards(event) {
            event.preventDefault();
            const isValid = await this.$refs.blockform.validate();
            if (isValid) {
                this.busy_blocking = true;
                await apiClient.post('/vue/cardorder/' + this.order.OrderID + '/block/cards', { card_series_id: this.block.item.serie.CardSeriesID, ...this.block.form })
                    .then((response) => {
                        this.busy_blocking = false;
                        this.$bvModal.hide('modal-block-cards');
                        this.block.form.comment = '';
                        this.block.form.selection = null;
                        this.block.item = null;
                        this.$swal({
                            title: 'Spärrade kort!',
                            text: response.data.affected + 'st kort spärrades.',
                            icon: 'success',
                            timer: 5000,
                        });
                    }).catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.blockform.setErrors(parsederror);
                        }
                        this.$refs.btnblockcards.triggerFailed();
                    });
            }
        },
    },
    computed: {
        old_system_url() {
            return window.config.app.old_system_url;
        },
        order_items() {
            if (this.order && this.order.items) {
                return this.order.items.filter((item) => !!item.serie);
            }
            return [];
        },
    },
};
</script>
